var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"wrapper login-content common-height common-content"},[_c('div',{staticClass:"wrapper title-block"},[_c('h2',{staticClass:"common-title"},[_vm._v(" ページが見つかりませんでした ")])])])])
}]

export { render, staticRenderFns }